import { elementType } from '@/vars'
import PathElement from './PathElement'
import TrackModifier from './TrackModifier'

export default class Track extends PathElement {
  constructor(data) {
    super(data)
    this.type = elementType.TRACK
    this.arrowsVisible = false
    this.clear = false
    this.arrowsArr = []
  }

  get directions() {
    return this.data.directions
  }

  get angle() {
    switch (this.orientation) {
      case 'n': return 270
      case 'e': return 0
      case 's': return 90
      case 'w': return 180
      default: return 0
    }
  }

  get isTrackElement() {
    return true
  }

  set displayArrows(flag) {
    this.arrowsVisible = flag
  }

  set clearArray(flag) {
    this.clear = flag
  }

  set setArrowsArr(modifiers) {
    this.arrowsArr = modifiers
  }

  get offset() {
    return [12, 12]
  }

  get modifiers() {
    const modifiers = []
    if (this.directions.length === 1 && this.layout === 'E') {
      const direction = this.directions[0]
      const data = {
        parent: this,
        direction
      }
      modifiers.push(new TrackModifier(data))
    }
    return modifiers
  }

  draw(ctx) {
    ctx.save()
    const x = this.scale.x(this.cell[1]) + this.radius
    // const y = this.scale.x(this.cell[0]) + this.radius
    const y = this.scale.y(this.cell[0]) + this.radius
    ctx.translate(x, y)
    const p = new Path2D(this.path)
    ctx.rotate(this.angle * (Math.PI / 180))
    ctx.translate(-this.radius, -this.radius)
    ctx.fillStyle = this.fillStyle
    ctx.fill(p)
    ctx.translate(this.radius, this.radius)
    ctx.rotate(0 - (this.angle * (Math.PI / 180)))
    ctx.translate(-x, -y)
    if (this.arrowsVisible) {
      const offset = this.offset
      this.arrowsArr.forEach((trackMod) => {
        if (trackMod.modifiers) {
          trackMod.modifiers.draw(ctx, trackMod.x - offset[0], trackMod.y - offset[1])
        }
      })
    }
    this.arrowsArr = this.clear ? [] : this.arrowsArr
    ctx.restore()
  }

  get path() {
    switch (this.layout) {
      case 'E':
        return 'M100,37V63H0V37Z'
      case 'C':
        return 'M63,49v51H37V75A12,12,0,0,0,25,63H0V37H51A12,12,0,0,1,63,49Z'
      case 'G':
        return 'M100,37V63H75A12,12,0,0,0,63,75v25H37V75A12,12,0,0,0,25,63H0V37Z'
      default:
        return 'M100,37V63H75A12,12,0,0,0,63,75v25H37V75A12,12,0,0,0,25,63H0V37H25A12,12,0,0,0,37,25V0H63V25A12,12,0,0,0,75,37Z'
    }
  }
}
